module.exports = __webpack_public_path__ + "img/sparking-change-deliver.cf133039.png";